<template>
    <div class="row" @click="employeeClick(employee.id)" :class="active ? 'active' : ''">
        <div class="col avatar-col">
            <div class="img">
                <img :src="employee.image"/>
            </div>
        </div>
        <div class="sub-row">
            <div class="col name-col">
            <p>{{fullName}}</p>
            </div>
            <div class="mobile-row">
                <div v-show="employee.status" class="col status-col">
                    <div class="sub-col"><p>{{employee.status}}</p></div>
                </div>
                <div v-show="employee.position && !employee.subPositions" class="col position-col"><p>Риэлтор</p></div>
                <div v-show="employee.position && employee.subPositions" class="col position-col">
                    <div class="sub-col main"><p>{{employee.position}}</p></div>
                    <div class="sub-col"><p v-for="(pos, index) in employee.subPositions" :key="index">{{pos}}</p></div>
                </div>

                <div class="col tel-col">
                    <a @click.stop="" :href="'tel:'+ employee.phone.replace(/[-+()\s]/g, '')">{{employee.phone}}</a>
                </div>
                <!--<div v-show="!showQuetionnaire" class="col info-col"><p>{{employee.additionalStatus}}</p></div>-->
                <div v-show="showQuetionnaire" class="col sub-links-col">
                    <p><a @click.stop.prevent="getQuestionnaire" href data-popup="human-questionnaire-popup"
                          class="js-open-popup bg-icon">
                        Анкета
                        <span class="icon"><icon-list width="12" height="12" viewBox="0 0 18 18"/></span>
                    </a></p>
                    <p><a @click.stop.prevent="getTest" href data-popup="human-test-popup" class="js-open-popup bg-icon test-icon">
                        Тест
                        <span class="icon"><icon-base width="15" height="10" viewBox="0 0 15 10"><icon-list-checked2/></icon-base></span>
                    </a></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions, mapMutations} from "vuex"
    import TestView from "./TestView";
    import QuestionnaireView from "./QuestionnaireView";
    import IconList from "../common/icons/IconList";
    import IconBase from "../common/IconBase";
    import IconListChecked2 from "../common/icons/IconListChecked2";

    export default {
        name: 'people-list-item',
        components: {
            IconListChecked2,
            IconBase,
            IconList
        },
        props: {
            employee: Object,
            showQuetionnaire: {
                type: Boolean,
                default: false
            },
            active: Boolean
        },
        computed: {
            fullName() {
                return this.employee.name + ' ' + this.employee.sername + ' ' + this.employee.patronymic
            }
        },
        methods: {
            ...mapActions('people',['getEmployee']),
            ...mapActions([
                'switchPopup'
            ]),
            ...mapMutations([
                'setPopupComponent',
            ]),
            employeeClick(id) {
                this.getEmployee(id).then(() => {
                    this.$router.push({path: '/people/' + id}).catch(() => {
                        //console.log(err);
                    })
                })
            },
            getQuestionnaire() {
                this.setPopupComponent(QuestionnaireView);
                this.switchPopup(true)
            },
            getTest() {
                this.setPopupComponent(TestView);
                this.switchPopup(true)
            }
        },
    }
</script>

<style scoped>

</style>
